import React from 'react'
import { defaults, Bar } from 'react-chartjs-2'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import { makeStyles } from '@material-ui/core/styles'

defaults.global.defaultFontColor = 'white'
const options = {
  legend: {
    display: false,
    labels: {
      fontColor: '#FFFFFF',
    },
  },
}

const useStyles = makeStyles({
  card: {
    backgroundColor: '#3A4149',
    border: '1px solid #23282c',
    boxShadow: 'none',
    marginBottom: '1.5rem',
  },
  cardTitle: {
    borderBottom: '1px solid #23282c',
    padding: '.75rem 1.25rem',
    backgroundColor: '#343b41',
  },
  title: {
    color: '#e4e7ea',
    fontSize: '.875rem',
    fontWeight: '400',
    margin: '0',
  },
})

const BarChart = ({ data, titleChart }) => {
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      <div className={classes.cardTitle}>
        <h2 className={classes.title}>{titleChart}</h2>
      </div>
      <CardContent>
        <Bar data={data} options={options} />
      </CardContent>
    </Card>
  )
}
export default BarChart
